import { useCallback } from "react";
import { useUserState } from "./useUserState";

/** Decimals offered for an odometer; three shows it to the metre. */
export const ODOMETER_DECIMAL_OPTIONS = [0, 1, 2, 3] as const;

export type OdometerDecimals = (typeof ODOMETER_DECIMAL_OPTIONS)[number];

export const DEFAULT_ODOMETER_DECIMALS: OdometerDecimals = 3;

const DEFAULTS = { decimals: DEFAULT_ODOMETER_DECIMALS as number };

/**
 * How many decimals the user wants on odometers, remembered per user. One setting for the
 * fleet check and the checklist, so the same vehicle reads the same on both.
 */
export function useOdometerDecimals() {
  const { value, setValue } = useUserState("odometer:decimals", DEFAULTS);

  const decimals =
    ODOMETER_DECIMAL_OPTIONS.find(option => option === value.decimals) ?? DEFAULT_ODOMETER_DECIMALS;
  const setDecimals = useCallback((next: OdometerDecimals) => setValue({ decimals: next }), [setValue]);

  return { decimals, setDecimals };
}
